import decode from 'jwt-decode';
import axios from 'axios';

const createBrowserHistory = require("history").createBrowserHistory;
const newHistory = createBrowserHistory();

const ACCESS_TOKEN_KEY = 'access_token';
//const BASE_URL = 'http://restauranteifpbbackend.herokuapp.com/api';
//const BASE_URL = 'http://192.168.0.117:3000/api';
//const BASE_URL = 'http://10.0.0.114:3000/api';
const BASE_URL = 'http://192.168.0.4:3000/api';

export function login(matricula, senha, successCallback, errorCallback) {
  axios.post(`${BASE_URL}/authenticate`, { matricula, senha })
    .then((response) => {
      if (successCallback) {
        successCallback(response.data);
      }
    }).catch((error) => {
      if (error.response){
        if (errorCallback) {
          errorCallback(error.response.data);
        }
      } else {
        console.log(error);
      }
    });
}

export function logout() {
  clearAccessToken();
  newHistory.push('/');
}

export function requireAuth(nextState, replace) {
  if (!isLoggedIn()) {
    replace({pathname: '/'});
  }
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}


function clearAccessToken() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}

// Helper function that will allow us to extract the access_token and id_token
// function getParameterByName(name) {
//   let match = RegExp('[#&]' + name + '=([^&]*)').exec(window.location.hash);
//   return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
// }

// Get and store access_token in local storage
// export function setAccessToken() {
//   let accessToken = getParameterByName('access_token');
//   localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
// }
export function setAccessToken(accessToken) {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
}

export function isLoggedIn() {
  const accessToken = getAccessToken();
  const res = !!accessToken && !isTokenExpired(accessToken);
  return res;
}

function getTokenExpirationDate(encodedToken) {
  const token = decode(encodedToken);
  if (!token.exp) { return null; }

  const date = new Date(0);
  date.setUTCSeconds(token.exp);

  return date;
}

function isTokenExpired(token) {
  const expirationDate = getTokenExpirationDate(token);
  return expirationDate < new Date();
}
